import { Spinner, type SpinnerProps } from "@chakra-ui/react";

export function SpinnerStyled(props: SpinnerProps) {
  return (
    <Spinner thickness="3px" speed="0.65s" color="brand.500" size="md" flexShrink={0} {...props} />
  );
}
